import { Outlet } from 'react-router-dom'

import { SalaryAdvanceSettingsPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import PageLoading from 'modules/layout/components/Page/Loading'

const RootPage = () => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(SalaryAdvanceSettingsPageDocument, {
    variables: { companyId: company.id },
  })

  const canManage = data?.salaryAdvance?._policies?.manageSalaryAdvance?.can

  if (loading) {
    return <PageLoading />
  }

  return (
    <AuthorizeUser authorizeFn={() => canManage ?? false}>
      <Outlet />
    </AuthorizeUser>
  )
}

export default RootPage



